// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command

export const environment = {
  production: false,
  envName: 'dev',
  apiUrl: '',
  defaultLanguage: 'en-US',
  supportedLanguages: ['ru-RU', 'en-US', 'ar-AR'],
  stripeKey: 'pk_test_51IipxpBIMZTJKM1cz1agFcNtoxQyQaVHfoSphxhKhFrasxT1GAOlWKrKjH6wzYxrRJO7KvwUymC0yBgztJWM4EAu00MJAmXyge',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
